// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

const servicesItems = [
    {
        id: 'housing',
        textValue: <FormattedText value="mortgageRequestPanel-insurancesRelatedHousingDamage" />,
        iconClass: 'icon-desperfectos-vivienda mortgage-request-insurances-related-modal__section-info-services-list-item--icon'
    },
    {
        id: 'legalProtection',
        textValue: <FormattedText value="mortgageRequestPanel-insurancesRelatedLegalProtection" />,
        iconClass: 'icon-proteccion-juridica mortgage-request-insurances-related-modal__section-info-services-list-item--icon'
    },
    {
        id: 'streetRobery',
        textValue: <FormattedText value="mortgageRequestPanel-insurancesRelatedStreetRobery" />,
        iconClass: 'icon-atraco mortgage-request-insurances-related-modal__section-info-services-list-item--icon'
    },
    {
        id: 'handsAtHome',
        textValue: <FormattedText value="mortgageRequestPanel-insurancesRelatedHandsAtHome" />,
        iconClass: 'icon-manitas mortgage-request-insurances-related-modal__section-info-services-list-item--icon'
    },
    {
        id: 'informaticAssistance',
        textValue: <FormattedText value="mortgageRequestPanel-insurancesRelatedInformaticAssitance" />,
        iconClass: 'icon-asistencia-informatica mortgage-request-insurances-related-modal__section-info-services-list-item--icon'
    }
];

const BuildServicesItems = (props) => {
    const { insuranceModalIconFlag } = props;
    const noStreetRoberyItems = servicesItems.filter(item => {
        return item.id !== 'streetRobery';
    })
    const serviceItemsToRender = !!insuranceModalIconFlag ? noStreetRoberyItems : servicesItems;
    const listItemsClass = classNames('mortgage-request-insurances-related-modal__section-info-services-list-item', {
        'mortgage-request-insurances-related-modal__section-info-services-list-item--four-items': !!insuranceModalIconFlag
    });
    const serviceItem = serviceItemsToRender.map(item => {
        return (
            <div key={item.id} className={listItemsClass}>
                <i className={item.iconClass}></i>
                <span className="mortgage-request-insurances-related-modal__section-info-services-list-item--text">
                    {item.textValue}
                </span>
            </div>
        );
    });

    return serviceItem;
};

BuildServicesItems.propTypes = {
    insuranceModalIconFlag: PropTypes.bool.isRequired,
};

module.exports = BuildServicesItems;